<div
  class="headerWrapper"
>
  <div
    class="headerContentContainer"
  >
    <div
      class="backSection"
    >
      <div
        class="backSectionWrapper"
        (click)="backClickHandler()"
      >
        <div
          class="iconContainer"
        >
          <img src="/static/img/arrow-back.svg" alt="backToRatingsList">
        </div>
        <div
          class="labelContainer"
        >
          {{backLabel}}
        </div>
      </div>
    </div>
    <div
      class="titleAndButtonSection"
    >
      <div
        class="ratingTitle"
      >
        {{certainRatingTitle()}}
      </div>
      <button
        *ngIf="editRatingButtonIsAvailable()"
        class="btn btn-log btn-lg editRatingButton"
        (click)="editRatingRedirector()"
      >
        {{editRatingButtonName}}
      </button>
    </div>
  </div>
</div>
